export default __webpack_public_path__ + "static/hero.light-9dd69866d70da8c239251e44b02fadf6.png";